import { useData } from "./DataContext.js";

import { CSSTransition, TransitionGroup } from "react-transition-group";

export default function DialoguePlacePicture (props)
{
    const gData = useData();

    const placeId = gData.state.currentDialogue !== null && gData.state.showModals.dialogue ? gData.state.currentPlaceId : null;
    //const charId = gData.state.currentDialogue !== null && gData.state.showModals.dialogue ? gData.state.currentDialogue.charId : null;

    const url = placeId === null ? "none" : "url(" + gData.gameId + "/pictures/places/" + placeId + ".jpg" + ")";

    return (
	<TransitionGroup>
	    <CSSTransition timeout={1000} key={placeId} classNames="fade" appear>
		<div>
		    <div className={"position-absolute start-0 top-0 vw-100 vh-100"}
			 style={{ zIndex: 0, backgroundImage: url, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
		    </div>
		</div>
	    </CSSTransition>
	</TransitionGroup>
    );
}
